import { render, staticRenderFns } from "./toast-v2.vue?vue&type=template&id=10f6770c&scoped=true&"
import script from "./toast-v2.vue?vue&type=script&lang=js&"
export * from "./toast-v2.vue?vue&type=script&lang=js&"
import style0 from "./toast-v2.vue?vue&type=style&index=0&id=10f6770c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f6770c",
  null
  
)

export default component.exports